export default "__VITE_ASSET__C0Lxo0XG__"